import {
  ListItem,
  ListItemIcon,
  ListItemProps,
  ListItemText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

type InvoiceListItemProps = Omit<ListItemProps, 'children'> & {
  createdAt?: Date;
  totalTTC?: number;
};

export function InvoiceListItem(
  props: Readonly<InvoiceListItemProps>,
): React.JSX.Element {
  const { createdAt, totalTTC, ...listItemProps } = props;
  const { t } = useTranslation();

  return (
    <ListItem {...listItemProps}>
      <ListItemIcon>
        <RequestQuoteIcon />
      </ListItemIcon>
      <ListItemText
        primary={
          createdAt
            ? t('invoice-v1.list-item.primary', {
                value: createdAt,
              })
            : t('invoice-v1.card.fallback')
        }
        secondary={
          totalTTC
            ? t('invoice-v1.list-item.secondary', {
                value: totalTTC,
              })
            : t('invoice-v1.card.fallback')
        }
      />
    </ListItem>
  );
}
